var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPushDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34717 7.90759C5.34717 6.94109 6.13067 6.15759 7.09717 6.15759H49.0972C50.0637 6.15759 50.8472 6.94109 50.8472 7.90759V49.9076C50.8472 50.8741 50.0637 51.6576 49.0972 51.6576H7.09717C6.13067 51.6576 5.34717 50.8741 5.34717 49.9076C5.34717 48.9411 6.13067 48.1576 7.09717 48.1576H47.3472V9.65759H7.09717C6.13067 9.65759 5.34717 8.87409 5.34717 7.90759Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07393 6.48793C6.53027 6.15902 7.11691 6.06952 7.65057 6.24741L28.6506 13.2474C29.3652 13.4856 29.8472 14.1544 29.8472 14.9076V42.9076C29.8472 43.6609 29.3652 44.3296 28.6506 44.5678L7.65057 51.5678C7.11691 51.7457 6.53027 51.6562 6.07393 51.3273C5.61758 50.9984 5.34717 50.4701 5.34717 49.9076V7.90759C5.34717 7.34507 5.61758 6.81685 6.07393 6.48793ZM8.84717 10.3356V47.4796L26.3472 41.6463V16.1689L8.84717 10.3356Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0972 24.8243C22.0637 24.8243 22.8472 25.6078 22.8472 26.5743V31.2409C22.8472 32.2074 22.0637 32.9909 21.0972 32.9909C20.1307 32.9909 19.3472 32.2074 19.3472 31.2409V26.5743C19.3472 25.6078 20.1307 24.8243 21.0972 24.8243Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushDoor);
export default __webpack_public_path__ + "static/media/push-door.c23212ea.svg";
export { ForwardRef as ReactComponent };